import type { AssetAggregateCardAspectRatioEnum } from '@frameio/graphql-client/generated';

export const aspectRatioToNumber: Record<
  AssetAggregateCardAspectRatioEnum,
  number
> = {
  HORIZONTAL: 16 / 9,
  SQUARE: 1,
  VERTICAL: 9 / 16,
};

export const aspectRatioToString: Record<
  AssetAggregateCardAspectRatioEnum,
  string
> = {
  HORIZONTAL: '16/9',
  SQUARE: '1/1',
  VERTICAL: '9/16',
};
